import { Select } from '@backstage/ui';
import { Key } from 'react';

interface ModernSelectProps {
  options: { label: string; value: string; disabled?: boolean }[];
  selectionMode?: 'single' | 'multiple';
  value: string | string[];
  onChange: (value: Key | Key[] | null) => void;
  label: string;
  secondaryLabel?: string;
  description?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
  isDisabled?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
  emptyOptionLabel?: string;
}

export function ModernSelect(props: Readonly<ModernSelectProps>) {
  const {
    options: inputOptions,
    selectionMode = 'single',
    value,
    onChange,
    label,
    secondaryLabel,
    description,
    placeholder = 'Select an option',
    size = 'small',
    isDisabled = false,
    isRequired = false,
    isInvalid = false,
    emptyOptionLabel,
  } = props;

  const options = emptyOptionLabel
    ? [{ label: emptyOptionLabel, value: '' }, ...inputOptions]
    : inputOptions;

  return (
    <Select
      label={label}
      value={value}
      onChange={selectValue => onChange(selectValue)}
      selectionMode={selectionMode}
      options={options}
      secondaryLabel={secondaryLabel}
      description={description}
      placeholder={placeholder}
      size={size}
      isDisabled={isDisabled}
      isRequired={isRequired}
      isInvalid={isInvalid}
    />
  );
}
